import { Fragment } from 'react'
import PropTypes from 'prop-types'

const imageLink = (props) => {
    const { href, src, title } = props

    const renderInner = () => (
        <Fragment>
            <div className="image-link__image" 
                 style={{'backgroundImage': `url('${src}')`}} />
            <div className="image-link__title">{title}</div>
        </Fragment>
    )

    return <a className="image-link" href={href}>{renderInner()}</a>
}

imageLink.propTypes = {
    href: PropTypes.string.isRequired,
    src:  PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
}

export default imageLink